// Thin GraphQL-over-fetch client. All requests go through the same-origin
// /graphql proxy; auth is handled by authFetch.
import { authFetch } from "./auth";

export class GqlError extends Error {
  constructor(public errors: { message: string }[]) {
    super(errors.map((e) => e.message).join("; ") || "GraphQL error");
  }
}

export async function gqlRequest<T>(
  query: string,
  variables?: Record<string, unknown>,
  signal?: AbortSignal,
): Promise<T> {
  const res = await authFetch("/graphql", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ query, variables }),
    signal,
  });
  if (!res.ok) throw new GqlError([{ message: `request failed (${res.status})` }]);
  const json = (await res.json()) as { data?: T; errors?: { message: string }[] };
  if (json.errors?.length) throw new GqlError(json.errors);
  return json.data as T;
}

/** Identity template tag — exists for editor syntax highlighting only. */
export const gql = (strings: TemplateStringsArray, ...values: string[]): string =>
  strings.reduce((acc, s, i) => acc + s + (values[i] ?? ""), "");
